import { api } from "@/lib/api";
import { optionalAllowed } from "@/lib/consent";

const KEY = "lexv_practice_progress";
export const GOOD = 0.7;
// Declined cookies: keep progress in memory for this visit only
let mem = {};
const read = () => { if (!optionalAllowed()) return mem; try { return JSON.parse(localStorage.getItem(KEY)) || {}; } catch { return {}; } };
const write = (all) => { if (!optionalAllowed()) { mem = all; return; } try { localStorage.setItem(KEY, JSON.stringify(all)); } catch { /* quota */ } };
const empty = { last: 0, scores: {}, updated_at: "" };

export const progressKey = (part, tier) => `${part}-${tier}`;
export const getProgress = (key) => ({ ...empty, ...read()[key] });

const timers = {};
const push = (key) => {
  if (!localStorage.getItem("lexv_token")) return;
  clearTimeout(timers[key]);
  timers[key] = setTimeout(() => { api.put(`/progress/${key}`, getProgress(key)).catch(() => {}); }, 800);
};

const update = (key, fn) => {
  const all = read();
  all[key] = { ...fn({ ...empty, ...all[key] }), updated_at: new Date().toISOString() };
  write(all); push(key);
  return all[key];
};

export const setLast = (key, idx) => update(key, (p) => ({ ...p, last: idx }));
export const recordScore = (key, idx, itemId, score) =>
  update(key, (p) => ({ ...p, last: idx, scores: { ...p.scores, [itemId]: Math.max(p.scores[itemId] ?? 0, score) } }));

// Highest question number with a submitted answer (1-based), 0 if none
export const highestDone = (p, items) => items.reduce((m, it, i) => (it.id in p.scores ? i + 1 : m), 0);

export const statusOf = (p, itemId) => (!(itemId in p.scores) ? "new" : p.scores[itemId] >= GOOD ? "good" : "low");

export const syncProgress = async () => {
  try {
    const { data } = await api.get("/progress");
    const all = read();
    Object.entries(data || {}).forEach(([k, r]) => {
      const l = { ...empty, ...all[k] };
      const scores = { ...l.scores };
      Object.entries(r.scores || {}).forEach(([id, v]) => { scores[id] = Math.max(scores[id] ?? 0, v); });
      all[k] = { scores, last: (r.updated_at || "") > l.updated_at ? r.last : l.last, updated_at: [r.updated_at || "", l.updated_at].sort()[1] };
    });
    write(all);
    Object.keys(all).forEach(push);
    window.dispatchEvent(new Event("lexv-progress"));
  } catch { /* offline ok */ }
};

export const clearProgress = () => { mem = {}; localStorage.removeItem(KEY); };
